const getImageByFile = file => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => resolve(img);
    img.src = url;
    setTimeout(() => reject("Select another file"), 2000);
  });
};

export default getImageByFile;



// WEBPACK FOOTER //
// ./src/utils/getImageByFile.js